import { VIEW_PROJECT_ASSETS_DOWNLOAD } from "../constant/ActionType";

// Initial pagination shape
const defaultPagination = { current_page: 1, last_page: 1, per_page: 10, total: 0 };

export default function ProjectAssetsDownload_reducer(
    state = { data: [], masterData: null, pagination: defaultPagination, error: false },
    action
) {
    switch (action.type) {
        case VIEW_PROJECT_ASSETS_DOWNLOAD: {
            if (!action.data) {
                return { ...state, error: true };
            }

            const payload = action.data;
            const nestedData = payload.data;

            // Helper to extract pagination from a Laravel paginator object
            const extractPaginator = (paginatorObj, items) => {
                const { current_page, last_page, per_page, total, data, ...rest } = paginatorObj;
                const masterData = Object.keys(rest).length > 0 ? rest : null;
                return {
                    data: items,
                    masterData,
                    pagination: {
                        current_page: current_page ?? 1,
                        last_page: last_page ?? 1,
                        per_page: Number(per_page) || 10,
                        total: total ?? items.length,
                    },
                    error: false,
                };
            };

            // ── Shape A: Paginator is nested inside payload.data ──────────────────
            // { status: "success", data: { current_page: 1, data: [...] } }
            if (nestedData && typeof nestedData === "object" && !Array.isArray(nestedData) && Array.isArray(nestedData.data)) {
                return extractPaginator(nestedData, nestedData.data);
            }

            // ── Shape B: Payload itself is the Paginator ──────────────────────────
            // { current_page: 1, data: [...] }
            if (typeof payload === "object" && !Array.isArray(payload) && payload.current_page !== undefined && Array.isArray(nestedData)) {
                return extractPaginator(payload, nestedData);
            }

            // ── Shape C: Custom envelope with sibling data and pagination keys ────
            // { status: "success", data: [...], pagination: { current_page: 5, per_page: 50, ... } }
            if (Array.isArray(nestedData) && payload.pagination && typeof payload.pagination === "object") {
                const { current_page, last_page, per_page, total } = payload.pagination;
                return {
                    data: nestedData,
                    masterData: null,
                    pagination: {
                        current_page: current_page ?? 1,
                        last_page: last_page ?? 1,
                        per_page: Number(per_page) || 10,
                        total: total ?? nestedData.length,
                    },
                    error: false,
                };
            }

            // ── Shape D: Flat array (either payload.data or payload itself) ───────
            const flatArray = Array.isArray(nestedData) ? nestedData : (Array.isArray(payload) ? payload : null);
            if (flatArray) {
                return {
                    data: flatArray,
                    masterData: null,
                    pagination: { ...defaultPagination, total: flatArray.length },
                    error: false,
                };
            }

            // ── Shape D: Legacy object with existing_assets ───────────────────────
            if (nestedData && typeof nestedData === "object") {
                const items = Array.isArray(nestedData.existing_assets) ? nestedData.existing_assets : [];
                return {
                    data: items,
                    masterData: nestedData,
                    pagination: { ...defaultPagination, total: items.length },
                    error: false,
                };
            }

            // Unknown shape
            return { ...state, error: true };
        }
        default:
            return state;
    }
}
